module.exports = __webpack_public_path__ + "img/1.1f931542.png";